import { useContext, useState } from "react";
import {
  Button,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
// import FormSelect from "../../../components/FormSelect";
// import { getCompanies } from "../../../services/company.service";
// import { CompanyContext } from "../../../contexts/CompanyContext";
import { AuthContext } from "../../../contexts/AuthContext";
import { CompanyContext } from "../../../contexts/CompanyContext";

export default function Header() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [companies, setCompanies] = useState([]);
  const { selectedCompany } = useContext(CompanyContext);
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  // const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);
  //  const [profile, setProfile] = useContext(ProfileContext);
  const handleClick = () => {
    setIsActive((current) => !current);
    document.body.classList.toggle("sidebarAction");
  };

  // const [userDetails] = useContext(ProfileContext);

  return (
    <Navbar bg='white' variant='light' className='px-md-2' style={{ zIndex: 1 }}>
      <Container fluid className='px-3 px-xl-4 mh-54 d-flex'>
        <Button
          //  onKeyPress={handleKeyPress}
          color='white'
          role='button'
          tabIndex={0}
          onClick={handleClick}
          className='p-0 navMenuBtn'
        >
          <span
            className={
              isActive ? "menuTrigger position-relative active" : "menuTrigger position-relative"
            }
          ></span>
        </Button>

        <Link to='/' className='d-lg-none mx-2 mx-md-3 px-1'>
          <image className='img-fluid' width={75} height={46} />
        </Link>

        {/* <div
          className='ms-3'
          style={{ width: "300px", zIndex: 1, position: "relative", marginTop: "9px" }}
        >
          <FormSelect
            id='company'
            name='company'
            formGroupClasses='m-0'
            options={companies}
            onChange={(name, value) => {
              handleChangeCompany(value);
              // setFieldValue(name, value);
            }}
            value={selectedCompany}
          />
        </div> */}

        <Nav className='ms-auto align-items-center'>
          {/* <div
            className='documentLink me-md-2 me-1'
            // onClick={() => {
            //   window.open("https://techdocs.pfplogistics.com", "_blank");
            // }}
          >
            <div className='documentLinkIcon fs-15 fw-bold text-decoration-none p-0 position-relative w-40 h-40 rounded-circle d-inline-flex align-items-center justify-content-center'>
              document
            </div>
          </div> */}

          {/* <Dropdown
       
            className='notificationDropdown me-md-2 me-1'
          >
            <DropdownToggle
              variant='link'
              // id='dropdown-notification'
              className='fs-15 fw-bold text-decoration-none p-0 position-relative w-40 h-40 rounded-circle d-inline-flex align-items-center justify-content-center'
            >
              bell
              <span className='position-absolute top-0 end-0 rounded-circle bg-danger p-1 notifiyDot'>
                <span className='visually-hidden'>unread messages</span>
              </span>
            </DropdownToggle>{" "}
            <DropdownMenu align='end'>
              <DropdownItem>Coming soon...</DropdownItem>
            </DropdownMenu>
          </Dropdown> */}
          {/* <div className='vr mx-2 mx-md-4'></div> */}
          <Dropdown isOpen={dropdownOpen} toggle={toggle} className='profileDropdown ms-md-2 ms-1'>
            <DropdownToggle
              color='white'
              variant='link'
              id='dropdown-profile'
              className='border-0 fs-15 fw-bold text-decoration-none p-0 text-start'
            >
              <img
                alt='Profile'
                className='object-fit-cover rounded-circle'
                src='https://fastly.picsum.photos/id/953/200/200.jpg?hmac=S5zbAl9YqUc02Oezl6cR8gcLfF3pwkQ5_AcG8JXjeC0'
                width={46}
                height={46}
              />
              <div className='align-middle d-none d-md-inline-block ms-1 px-2 text-truncate mw-150'>
                <div>Super Admin</div>
                <small className='fw-semibold'>{selectedCompany.name}</small>
              </div>
            </DropdownToggle>

            <DropdownMenu align='end'>
              <DropdownItem
                onClick={() => {
                  navigate("/profile");
                }}
              >
                Profile
              </DropdownItem>
              <DropdownItem onClick={logout}>Logout</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Nav>
      </Container>
    </Navbar>
  );
}
